import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuth";
import { formatApiErrorDetail } from "@/lib/adminApi";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--ink)] text-[var(--bone)] flex items-center justify-center px-5" style={{ cursor: "auto" }}>
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
        <div className="font-display text-4xl mb-2">Balance<span className="text-[var(--terra)]">.</span></div>
        <p className="overline text-white/50 mb-10">CRM · Admin access</p>

        <label className="block mb-6">
          <span className="overline text-white/50">Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-2 w-full bg-transparent border-b border-white/25 focus:border-[var(--terra)] outline-none py-3 font-body text-lg"
            data-testid="admin-email"
            required
          />
        </label>
        <label className="block mb-8">
          <span className="overline text-white/50">Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-2 w-full bg-transparent border-b border-white/25 focus:border-[var(--terra)] outline-none py-3 font-body text-lg"
            data-testid="admin-password"
            required
          />
        </label>

        {error && <p className="text-[var(--terra-soft)] font-body text-sm mb-4" data-testid="admin-login-error">{error}</p>}

        <button type="submit" disabled={busy} className="btn-ink !bg-[var(--bone)] !text-[var(--ink)] w-full py-4 rounded-full disabled:opacity-50" data-testid="admin-login-btn">
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <a href="/" className="block text-center overline text-white/40 mt-8 hover:text-white/70">← Back to store</a>
      </form>
    </div>
  );
}
